import VectorLayer from 'ol/layer/Vector';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import { Feature } from 'ol';
import VectorSource from 'ol/source/Vector';
import { GeoJSON } from 'ol/format';

export class OLLayer<T extends GeoJSON.Geometry, U> {
  private layer!: VectorLayer | WebGLPointsLayer;
  private source!: VectorSource;
  private readonly createFeature!: (geoJSONFeature: GeoJSON.Feature<T, U>) => Feature;
  private readonly updateFeature!: (feature: Feature, properties: U) => void;

  constructor(
    layer: VectorLayer | WebGLPointsLayer,
    createFeature: (geoJSONFeature: GeoJSON.Feature<T, U>) => Feature,
    updateFeature: (feature: Feature, properties: U) => void
  ) {
    this.layer = layer;
    this.source = layer.getSource() as VectorSource;
    this.createFeature = createFeature;
    this.updateFeature = updateFeature;
  }

  public setFeatures(featureCollection: GeoJSON.FeatureCollection<T, U>) {
    const features = featureCollection.features.map(feature => this.createFeature(feature));
    this.source.clear();
    this.source.addFeatures(features);
  }

  public updateFeatures(properties: U[]) {
    properties.forEach((property: any) => {
      const feature = this.source.getFeatureById(property.id);
      this.updateFeature(feature, property);
    });
  }
}
